import { Outlet, useLocation } from "react-router-dom";
import { clearActingTenant, getActingTenant } from "src/Common/tenant";
import Header from "./header";
import SideMenu from "./sidemenu";

const SIDEMENU_WIDTH = 257;
const HEADER_HEIGHT = 60;

const LayoutWithTopBar = () => {
  const location = useLocation();
  // A /platform page sits above every tenant, so reaching one while a tenant is
  // entered — a typed URL or browser Back after Enter — means leaving it, the
  // same as the sidebar's EXIT. Done while rendering rather than in an effect
  // because the side menu and the page below both read the acting tenant as
  // they render: an effect would run too late and let this pass show the tenant
  // menu and fetch tenant-scoped data on a cross-tenant page.
  if (location.pathname.startsWith("/platform") && getActingTenant()) {
    clearActingTenant();
  }

  return (
    <div className="w-full h-screen overflow-x-hidden">
      <SideMenu />

      <div
        className="contentWidth flex flex-col h-screen"
        style={{
          marginLeft: `${SIDEMENU_WIDTH}px`,
          paddingTop: `${HEADER_HEIGHT}px`,
        }}
      >
        <div
          className="fixed top-0 right-0 bg-white"
          style={{
            left: `${SIDEMENU_WIDTH}px`,
            height: `${HEADER_HEIGHT}px`,
            zIndex: 11,
          }}
        >
          <Header />
        </div>

        <div className="flex-1 min-h-0">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default LayoutWithTopBar;
